module.exports = __webpack_public_path__ + "static/media/urbangoo22.93c2513a.webp";